var map = {
	"./autocisterna.png": "a0d5",
	"./defaultmarker.png": "6213",
	"./gps.png": "2c4b",
	"./gps1.png": "d991",
	"./gruarancione.png": "dedd",
	"./grudefault.png": "8074",
	"./grugiallo.png": "b829",
	"./grurosso.png": "bb2c",
	"./gruverde.png": "cebc",
	"./impiantoarancione.png": "abcd",
	"./impiantodefault.png": "079d",
	"./impiantogiallo.png": "8d88",
	"./impiantorosso.png": "e111",
	"./impiantoverde.png": "ec29",
	"./impiantoviola.png": "6e9e",
	"./mezzo0.png": "82b2",
	"./mezzo1.png": "f4ef",
	"./mezzo2.png": "95e3",
	"./noneicon.png": "c025",
	"./piattaformaarancione.png": "51ec",
	"./piattaformadefault.png": "3f59",
	"./piattaformagiallo.png": "e24b",
	"./piattaformarosso.png": "6167",
	"./piattaformaverde.png": "67a2",
	"./pratonevoso.png": "e5f6",
	"./vehiclearancione.png": "185e",
	"./vehicledefault.png": "22da2",
	"./vehiclegiallo.png": "8debe",
	"./vehiclerosso.png": "354d",
	"./vehicleverde.png": "393f",
	"./vehicleviola.png": "b18d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5281";